import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteUserDocument } from '@arrived/api_v2';
import { UserDocument, UserDocumentId } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { userDocumentsKeyFn } from './userDocuments.keys';

export function useDeleteUserDocumentMutation(options?: UseMutationOptions<UserDocument, UserDocumentId>) {
  const queryClient = useQueryClient();

  return useMutation((documentId) => deleteUserDocument(documentId), {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(userDocumentsKeyFn(data.userId));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
